module.exports = __webpack_public_path__ + "static/media/innovation-2.00ee0aa4.png";